<template>
  <a-date-picker :disabled="disabled" v-model="momentVal" :locale="locale"  @change="onChange"></a-date-picker>
</template>

<script>
    import mixin from '../mixin/AExtStringMixin'
    import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
    import moment from 'moment';
    import 'moment/locale/zh-cn';
    export default {
        name: "index",
        mixins:[mixin],
        props:{
            disabled:{
                type:Boolean,
                default:false
            }
        },
        data() {
            return {
                locale,
                moment,
                momentVal:null,
                localValue:''
            }
        },
        created(){
            this.init();
        },
        watch: {
            localValue(val) {
                if(this.localValue)
                    this.momentVal = this.moment(this.localValue, 'YYYY-MM-DD')
                else{
                    this.momentVal=undefined;
                }
            }
        },
        methods:{
            init(){
                if(this.localValue) {
                    this.momentVal = this.moment(this.localValue, 'YYYY-MM-DD')
                }
            },
            onChange(date,dateStr)
            {
                this.localValue=dateStr;
            }
        }
    }
</script>

<style scoped>

</style>